module.exports = __webpack_public_path__ + "img/chlg-logo-colour.ff485b41.png";